
import React from 'react'
import debounce from 'lodash.debounce'

import style from './Search.module.scss'

const onSearch = debounce((event, engine) => engine.search(event), 300)

const Input = ({
  microcopy,
  engine
}) => (
  <>
    {/* By only showing the input when the state changes, we allow for autoFocus to work */}
    { engine.state.showSearch && 
      <input 
        className={style.input} 
        placeholder={ microcopy.text('search.prompt') }
        onChange={(event) => onSearch(event.target.value, engine)}
        onKeyUp={(event) => engine.keyup(event)}
        autoFocus 
      />
    }   
  </>
)

export default Input